<template>
  <div>
    <transition name="modal" v-if="show">
      <div>
        <div
          class="modal-mask"
          v-if="configs.mask == true"
          @click="onMaskClick"
        ></div>
        <div class="modal show" tabindex="-1" role="dialog">
          <div
            class="modal-dialog"
            v-bind:class="configs.position"
            role="document"
            v-bind:style="{ width: width + 'px' }"
          >
            <div class="modal-content">
              <div class="modal-header">
                <div @click="hideModal()" v-if="enableClose">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" class="icon-close"></span>
                  </button>
                </div>
                <h4
                  class="modal-title"
                  v-bind:style="cssTitle"
                  v-html="title"
                ></h4>
              </div>
              <div class="modal-body">
                <slot name="body"></slot>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                  <div ref="buttons" class="list_button_modal">
                    <div
                      v-for="(button, index) in configs.buttons"
                      :key="index"
                    >
                      <BaseButton
                        type="button"
                        v-bind:class="[
                          button.class,
                          index !== 0 ? 'not-first-button' : '',
                        ]"
                        :disabled="button.isDisableBtn ? disabled : false"
                        @click="button.callback"
                      >
                        {{ button.label }}
                      </BaseButton>
                    </div>
                  </div>
                </slot>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
      </div>
    </transition>
  </div>
</template>

<script>
window.CommonModal = {
  show: function (modalName, configs) {
    window.app.$broadcast("showCommonModal", modalName, configs);
  },
  hide: function (modalName) {
    window.app.$broadcast("hideCommonModal", modalName);
  },
};

import BaseButton from "../common/Button.vue";
export default {
  components: {
    BaseButton,
  },
  props: {
    name: {
      default: "defaultModal",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
    cssTitle: {
      default: () => {},
      type: Object,
    },
    enableClose: {
      default: true,
      type: Boolean,
    },
    width: {
      default: "",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      show: false,
      configs: {
        mask: true,
        buttons: [],
        close: null,
        closeOnClickOutside: true,
      },
    };
  },
  methods: {
    hideModal() {
      if ($("body").hasClass("modal-open")) {
        $("body").removeClass("modal-open");
      }
      window.app.$broadcast("hideCommonModal", this.name);
    },

    onMaskClick() {
      if (this.configs.closeOnClickOutside !== false && this.enableClose) {
        // this.hideModal();
      }
    },

    focusButton() {
      if (!this.$refs.buttons) {
        return;
      }
      let buttons = this.$refs.buttons.getElementsByTagName("button");
      let index = window._.findIndex(this.configs.buttons, (button) => {
        return button.focused;
      });
      if (index >= 0) {
        buttons[index].focus();
      }
    },
  },
  created() {
    let self = this;
    this.$on("showCommonModal", (modalName, userConfigs) => {
      if (modalName == self.name) {
        self.show = true;
        self.configs = Object.assign(self.configs, userConfigs);
        if (self.configs.onShown) {
          window.setTimeout(function () {
            self.configs.onShown();
          }, 0);
        }

        this.$nextTick(() => {
          this.focusButton();
        });
      }
    });
    this.$on("hideCommonModal", (modalName) => {
      if (modalName == self.name) {
        self.show = false;

        if (self.configs.close) {
          self.configs.close();
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: block;
  transition: opacity 0.3s ease;
}

.modal {
  text-align: center;
  padding: 0 !important;
  z-index: 10000;
  pointer-events: none;

  &:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -4px;
  }

  .modal-dialog {
    height: 330px;
    vertical-align: middle;
    display: inline-block;
    text-align: left;

    &.bottom-left {
      position: absolute;
      left: 15px;
      bottom: 15px;
      margin: 0;
    }

    &.bottom-right {
      position: absolute;
      right: 15px;
      bottom: 15px;
      margin: 0;
    }

    .modal-content {
      height: 330px;
      border-radius: 0px;
      pointer-events: auto;
      .close {
        height: 20px;
        width: 20px;
        opacity: 0.9;
        z-index: 100;
        position: relative;
        outline: none;
        background: transparent !important;
        &:hover {
          opacity: 1;
        }
        .icon-close {
          border-radius: 50%;
          color: $color-grey;
          line-height: 32px;
          overflow: hidden;
          text-align: center;
          display: inline-block;
          font-size: $font-smaller;
          float: right;
          width: 30px;
          height: 30px;
          margin: 0px 0px 0 0;
          cursor: pointer;
          &:hover {
            background-color: $color_concrete;
            color: $color-grey;
          }
        }
      }
      .modal-header {
        padding: 16px 16px 16px 45px;
        position: relative;
        border-bottom: none;
        // .icon-close {
        //   position: absolute;
        //   right: 14px;
        //   top: 14px;
        //   font-size: 12px;
        //   font-weight: 600;
        //   color: black;
        //   text-shadow: none;
        //   opacity: 0.35;
        //   cursor: pointer;
        //   &:hover {
        //     opacity: 0.4;
        //   }
        // }
      }
      .modal-title {
        color: $color_mine_shaft;
        font-size: 20px;
        text-transform: uppercase;
      }

      .modal-body {
        padding: 15px 65px;
      }

      .modal-footer {
        border-top: 0px;
        padding-top: 10px;
        padding-bottom: 55px;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        margin-top: 0px;
      }
      .list_button_modal {
        button {
          width: 100px;
          height: 35px;
        }
        .not-first-button {
          margin-left: 20px;
        }
        .btn-modal {
          background-color: $color-caribbean-green;
          color: $color-white;
          height: 35px;
          position: relative;
          padding: 0px 20px;
          display: inline-block;
          cursor: pointer;
          font-size: $font-smaller;
          border: 1px solid $color-caribbean-green;
          text-align: center;
          text-transform: uppercase;
          font-weight: 600;
          border-radius: 3px;
          margin-right: 10px;
          min-width: 90px;
          width: fit-content;
          font-family: $mulish-regular;
          &:hover {
            background-color: $color-aquamarine;
            border-color: $color-aquamarine;
          }
        }
        > div:last-child {
          display: inline-block;
          float: none;
        }
        > div:first-child {
          display: inline-block;
          float: none;
        }
      }
    }
  }

  .group-setting-detail {
    .modal-content {
      height: 280px;
      .modal-header {
        padding: 15px 20px 15px 25px;
        .modal-title {
          text-transform: none;
        }
      }
      .modal-body {
        padding: 0px 20px 15px 25px;
      }
      .modal-footer {
        padding-bottom: 15px;
      }
    }
  }
  .bitmex {
    .modal-content {
      height: 150px;
      .modal-header {
        padding: 15px 20px 15px 25px;
        .modal-title {
          text-transform: none;
        }
      }
      .modal-body {
        padding: 0px 20px 15px 25px;
      }
      .modal-footer {
        padding-bottom: 15px;
      }
    }
  }
  .add-group {
    .modal-content {
      height: 400px;
      .modal-header {
        padding: 15px 20px 15px 25px;
      }
      .modal-body {
        padding: 0px 90px 15px 90px;
      }
    }
  }
  .remove-group {
    .modal-content {
      height: 400px;
      .modal-header {
        padding: 15px 20px 15px 25px;
      }
      .modal-body {
        padding: 0px 90px 15px 90px;
      }
    }
  }
}
</style>
